import { createSelector } from 'reselect';

import { carrierDataSelectors } from 'wanderu-ducks-carriers';

import { CARRIER_IS_ACTIVE_DEFAULT } from '../constants';
import { selectRawFilterData } from './general';

function _selectCarriersFilterRawData(state, filterId) {
    return selectRawFilterData(state, filterId).carriers;
}

function _selectCarriers(state, filterId) {
    const carrierCodes = Object.keys(_selectCarriersFilterRawData(state, filterId));
    return carrierDataSelectors.selectCarrierData(state, carrierCodes);
}

function _mapCarriers(carrierFilterData, carriers) {
    return Object.entries(carrierFilterData)
        .reduce((map, [carrierCode, travelModeObj]) => {
            const carrier = carriers[carrierCode];
            const mappedData = Object.entries(travelModeObj)
                .reduce((map, [mode, isActive]) => ({
                    ...map,
                    [mode]: {
                        loading: !carrier,
                        name: carrier && carrier.name,
                        isActive,
                    },
                }), {});

            return {
                ...map,
                [carrierCode]: mappedData,
            };
        }, {});
}

const selectCarriersFilterData = createSelector(
    _selectCarriersFilterRawData,
    _selectCarriers,
    _mapCarriers,
);

function _isCarriersFiltered(carrierMap, travelModeToCheck) {
    return Object.values(carrierMap).some((travelModeMap) => {
        return Object.values(travelModeMap).some((isActive) => {
            return isActive !== CARRIER_IS_ACTIVE_DEFAULT;
        });
    });
}
const selectCarriersIsFiltered = createSelector(
    _selectCarriersFilterRawData,
    _isCarriersFiltered,
);

export {
    selectCarriersFilterData,
    selectCarriersIsFiltered,
};
